
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFuse02 as ObiFuse02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-fuse-02.js';
 
 
 

 
 export const ObiFuse02 = createComponent({
   react: React,
   tagName: 'obi-fuse-02',
   elementClass: ObiFuse02Element,
   events: {
     
   }
  });
 
 